import styled from "styled-components";

import { Text } from "/component/base";
import { getVariantStyle, VariantStyleProps } from "/component/base/Button/Button.styles";
import { layout } from "/styles";
import { ThemeType } from "/theme/default";

export const ProviderNoteContainer = styled.div(({ theme }) => ({
  padding: 16,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: theme.colors.backgroundSurfaceHover,
  borderRadius: theme.spacing[12],
  gap: 8,
  marginBottom: 16,
}));

export const TitleText = styled(Text)({
  fontSize: 18,
});

export const SubtitleText = styled(Text)(({ theme }) => ({
  fontSize: theme.fontSizes.body1,
  color: "#6C6C6C",
}));

export const RequestButton = styled.a<ThemeType & VariantStyleProps>(
  layout.flexCenter,
  ({ theme }) => getVariantStyle({ theme, $variant: "secondary" }),
  ({ theme }) => ({
    height: 40,
    marginTop: 8,
    padding: `${theme.spacing.none}px ${theme.spacing[12]}px`,
    textDecoration: "none",
  }),
);

export const ButtonText = styled(Text)(({ theme }) => ({
  fontSize: theme.fontSizes.body1,
}));
